import { render, staticRenderFns } from "./characterManager.vue?vue&type=template&id=3526d617&"
import script from "./characterManager.vue?vue&type=script&lang=js&"
export * from "./characterManager.vue?vue&type=script&lang=js&"
import style0 from "./characterManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports